import { RefObject, useEffect } from 'react';

/**
 * Hook to aggressively disable native HTML5 video controls.
 * Prevents conflicts with Shaka UI custom controls by using a MutationObserver
 * to immediately remove the controls attribute if it's ever added back.
 */
export const useDisableNativeControls = (videoRef: RefObject<HTMLVideoElement>) => {
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.controls = false;
    video.removeAttribute('controls');

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'controls') {
          if (video.hasAttribute('controls')) {
            video.removeAttribute('controls');
            video.controls = false;
          }
        }
      });
    });

    observer.observe(video, {
      attributes: true,
      attributeFilter: ['controls']
    });

    return () => {
      observer.disconnect();
    };
  }, [videoRef]);
};
